import React, { useContext, useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'

import { DomainContext } from '../../domain-repository/DomainRepository'

import additionalDriverIcon from './icons/additional-driver.png'
import gpsIcon from './icons/gps.png'
import wifiIcon from './icons/WIFI.svg'
import babySeatIcon from './icons/baby-seat.png'
import boosterSeatIcon from './icons/booster-seat.png'
import crossBorderIcon from './icons/cross-border.png'
import tpIcon from './icons/TP.svg'
import tollsIcon from './icons/tolls.png'
import acdw1Icon from './icons/ACDW1.svg'
import astopIcon from './icons/ASTOP.svg'
import paiIcon from './icons/PAI.svg'

import DriverInfoHeader from '../../components/PageHeader'
import { FooterWithPrice } from '../../components/Footer'
import withLang from '../../withLang'
import { AlertModal } from '../../components/alert-modal/AlertModal'
import TrackingPage from '../../components/TrackingPage'

const hideIfAcquired=['ADD1']

const iconNameMap = {
  ACDW1: acdw1Icon,
  ASTOP: astopIcon,
  PAI: paiIcon,
  ADD1: additionalDriverIcon,
  GPS: gpsIcon,
  WIFI: wifiIcon,
  CBF: crossBorderIcon,
  BABY0: babySeatIcon,
  BABY1: babySeatIcon,
  BABY2: babySeatIcon,
  BSEAT: boosterSeatIcon,
  TP: tpIcon,
  TOLLS: tollsIcon,
};

function ComfortExtrasPage(props) {
  const { t } = useTranslation();

  const {
    getComfortExtras,
    addExtra,
    removeExtra,
    getQuantityOfExtra,
    isCorporate,
    appFlowConfigs,
    getCorporateExtras,
    flowNextRoute,
    isIncompatibleExtra,
    rentalAgreementQuoteValue,
    canDisplayExtra,
    mapExtraPrice,
    getQuantityOfExtraInReservation,
    flowPreviousRoute,
    saveSessionExtras,
  } = useContext(DomainContext)

  const [additionalDriverModalOpen, setAdditionalDriverModalOpen] = useState(false)

  function getExtrasIDs() {
    const extras = appFlowConfigs.list.map(e => ({ extraID: e.id, order: e.order }))
      .filter(canDisplayExtra)
      .filter(e => appFlowConfigs.single.some(s => e.id === s.id) ? getQuantityOfExtra(e) === 0 : true)
      .map(mapExtraPrice)
      .filter(e => !!e)
      .filter(e => hideIfAcquired.includes(e.extraID) ? getQuantityOfExtra(e) === 0 : true)
      .sort((a, b) => a.order - b.order)
    return extras
  }

  const comfortExtras = getExtrasIDs() || []

  function getExtraActionButton(extra) {
    if (extra.acceptQty === 'true' && extra.extraID !== 'ADD1') {
      return (
        <div className="range d-flex">
          <a onClick={() => { if (getQuantityOfExtra(extra) > 0) { removeExtra(extra) } }}>
            <img src={require("../../assets/images/ico-minus-orange.png")} alt="" />
          </a>
          <span className="range-value">{getQuantityOfExtra(extra) + getQuantityOfExtraInReservation(extra.extraID)}</span>
          <a onClick={() => addExtra(extra)}><img src={require("../../assets/images/ico-plus-orange.png")} alt="" /></a>
        </div>
      )
    }
    if (getQuantityOfExtra(extra)) {
      return <button onClick={() => removeExtra(extra)} className="btn-add"></button>
    }

    if (extra.extraID === 'ADD1') {
      return (
        <button onClick={() => setAdditionalDriverModalOpen(true)} className="btn-add"></button>
      )
    }

    return (
      <AddSelectableExtraButton
        extra={extra}
        returnUrl={window.location.pathname}
        history={props.history}
      >
        <button className="btn-add"></button>
      </AddSelectableExtraButton>
    )
  }

  function ComfortExtrasItem({ extra, active, availabilityHint }) {
    const { t } = useTranslation();

    return (
      <div className={`list-extras board-background mt-2 ${active ? 'active' : ''}`}>
        <div className="block-header d-flex align-items-center">
          {iconNameMap[extra.extraID] &&
            <div className="ico">
              <img src={iconNameMap[extra.extraID]} alt={`${extra.extraID} icon`} />
            </div>
          }
          <div className="block-title">
            <h2>{t(`${extra.extraID}Name`)}</h2> {availabilityHint ? <i>({t(`${extra.extraID}Hint`)})</i> : ''}
          </div>
        </div>
        <div className="block-content mt-2">
          <p>
            {t(`${extra.extraID}ShortDescription`, t(`${extra.extraID}Description`))}
          </p>
        </div>
        <div className="row justify-content-end extras-action__line">
          <div className="block-value col d-flex align-items-center justify-content-end">
            <span>€{extra.pricePerDay || extra.totalPrice}/{extra.pricePerDay ? t('day') : t('total')}</span>
            {getExtraActionButton(extra)}
          </div>
        </div>
      </div>
    )
  }

  function nextRoute() {
    return flowNextRoute()
  }

  const handleNextClick = useCallback(() => {
    const extrasMapped = comfortExtras.map(extra => ({
      extraId: extra.extraID,
      price: extra.pricePerDay || extra.totalPrice,
      acquired: getQuantityOfExtra(extra) > 0,
      removedInReview: false,
      pageId: PageId,
    }))

    saveSessionExtras(extrasMapped)

    props.history.push(nextRoute())
  }, [comfortExtras, props.history, saveSessionExtras, getQuantityOfExtra])

  return comfortExtras.length > 0 ? (
    <div>
      <DriverInfoHeader
        title={t('comfort')}
        active={2}
        progress={'69.5%'}
        handleLogoClick={() => props.history.push('/start')}
      />
      <main className='page-layout'>
        <div className="container grow">
          <div className="main" style={{ height: '100%' }}>
            <div className="header text-center">
              <div className="text-center">
                <h2>{t('conformExtrasTitle')}</h2>
              </div>
            </div>
            <div className="block-container">
              {comfortExtras.map(extra =>
                <ComfortExtrasItem
                  key={extra.extraID}
                  extra={extra}
                  active={getQuantityOfExtra(extra)}
                  availabilityHint={['GPS'].includes(extra.extraID)}
                />
              )}
            </div>
          </div>
        </div>
        <FooterWithPrice
          totalPrice={rentalAgreementQuoteValue}
          totalPriceLabel={t('total')}
          handleNextClick={handleNextClick}
          handlePrevClick={() => flowPreviousRoute(props.history)}
        />
        <AlertModal
          isOpen={additionalDriverModalOpen}
          title={t('pleasefulfilAdditionalDriverInfo')}
          buttonLabel={t('OK')}
          handleClick={(e) => {
            setAdditionalDriverModalOpen(false)
            props.history.push({
              pathname: '/additional-driver-info-step/1',
              state: { returnTo: '/comfort-extras', reviewUrl: '/additional-driver-info-review', privacyReturnTo: '/additional-driver-info-review' }
            })
          }}
        />
      </main>
    </div>
  ) : <Redirect to={nextRoute()} />
}

const PageId = 83
export default withLang(TrackingPage(ComfortExtrasPage, PageId))

function AddSelectableExtraButton({ extra, history, children, returnUrl }) {
  const [isOpen, setIsOpen] = useState(false)
  const { addExtra } = useContext(DomainContext)
  const { t } = useTranslation()

  function onSelectExtra() {
    if (extra.extraID === 'ADD1') {
      setIsOpen(true)
    }

    else if (extra.extraID === 'UPSELLING') {
      history.push({
        pathname: '/upselling',
        state: { continueUrl: returnUrl }
      })
    } else if (extra.extraID === 'INSURANCE') {
      history.push({
        pathname: '/safety-packs',
        state: { continueUrl: returnUrl }
      })
    } else if (extra.extraID === 'BABYSEAT') {
      history.push({
        pathname: '/baby-seats',
        state: { continueUrl: returnUrl }
      })
    }

    else {
      addExtra(extra)
    }
  }

  return (
    <div onClick={onSelectExtra}>
      {children}
    </div>
  )
}
